module.exports = require('./convert')(
  ".exportsfunc\"#$&',/:;<>?@[]^`abdghijklmqvwyz{|}~",
  "юучзўкеыагтсЭ№;?эб.ЖжБЮ,\"х':ёфівпршолдьймцняХ/'Ё"
)
